module.exports = __webpack_public_path__ + "fonts/KaTeX_SansSerif-Bold.b9cd458.woff";